import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Row, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Edit, Trash2, PlusCircle, Download, Users, Share, User, ChevronRight, ChevronLeft } from 'react-feather';
import EventGroupInfo from './info';
import EventGroupAttendees from './attendees';
import EventGroupSessions from './sessions';
import EventGroupWaitlist from './waitlist';
import DeleteGroupModal from './modals/deleteGroupModal';
import API from '../../../utils/API';

import LoadingWizard from '../../../components/spinner/wizard';

import BasicSectionHeader from '../../../components/views/BasicSectionHeader';
import TabsContainer from '../../../components/views/TabsContainer';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import SectionHeader from '../../../components/views/SectionHeader';
import SectionFooter from '../../../components/views/SectionFooter';

class EventGroup extends Component {
	constructor(props) {
		super(props);
		const { match: { params } } = props;
		const group = props.groups.find((g) => g._id == params.groupId);
		this.state = {
			group: group,
			editedGroup: {},
			selectedSection: 0,
			deleteGroupModalOpen: false,
			loading: true,
			editing: false,
			addAttendeeToggle: false,
			importAttendeesToggle: false,
			addSessionToggle: false,
			importSessionsToggle: false,
			deleteAttendeesModalOpen: false,
			checkedAttendees: [],
			deleteSessionsModalOpen: false,
			checkedSessions: [],
			approveWaitlistModalOpen: false,
			deleteWaitlistModalOpen: false,
			checkedWaitlist: {},
			requiredFields: {
				name: false
			}
		};
	}

	getAttendeeFieldColumns = (event = {}) => {
		const columns = {
			firstName: 'First Name',
			lastName: 'Last Name',
			email: 'Email',
			status: 'Status',
			invited: 'Invited',
			attendance: 'Attendance',
			registered: 'Registered',
			checkedIn: 'Checked In',
			title: 'Title',
			description: 'Biography',
			phoneNumber: 'Phone Number',
			company: 'Company',
			textMessageOptIn: 'Text Message Opt-In',
			dietaryPreference: 'Dietary Preference',
			foodAllergies: 'Food Allergies',
			emergencyContactName: 'Emergency Contact Name',
			emergencyContactPhoneNumber: 'Emergency Contact Phone Number',
			address: 'Address',
			address2: 'Address 2',
			city: 'City',
			state: 'State',
			zip: 'Zip',
			country: 'Country',
			eventGroups: 'Groups',
			denialReason: 'Denial Reason',
			denialComment: 'Denial Comment',
			role: 'Role',
			bcc: 'BCC'
		};
		const columnTypes = {
			firstName: 'string',
			lastName: 'string',
			email: 'string',
			status: 'string',
			invited: 'bool',
			attendance: 'string',
			registered: 'bool',
			checkedIn: 'bool',
			title: 'string',
			description: 'string',
			phoneNumber: 'string',
			company: 'string',
			textMessageOptIn: 'bool',
			dietaryPreference: 'string',
			foodAllergies: 'string',
			emergencyContactName: 'string',
			emergencyContactPhoneNumber: 'string',
			address: 'string',
			address2: 'string',
			city: 'string',
			state: 'string',
			zip: 'string',
			country: 'string',
			eventGroups: 'string',
			denialReason: 'string',
			denialComment: 'string',
			role: 'string',
			bcc: 'string'
		};

		if (event?.experienceType === 'in-person' || event?.experienceType === 'hybrid') {
			const extraColumns = {
				rooming_arrivalDate: 'Rooming Arrival Date',
				rooming_arrivalTime: 'Rooming Arrival Time',
				rooming_checkInDate: 'Rooming Check-In Date',
				rooming_departureDate: 'Rooming Departure Date',
				rooming_departureTime: 'Rooming Departure Time',
				rooming_checkOutDate: 'Rooming Check-Out Date',
				rooming_numberOfDaysStay: 'Rooming Number of Nights',
				rooming_roomType: 'Rooming Room Type',
				rooming_hotelConfirmationNumber: 'Hotel Confirmation Number',
				rooming_paymentType: 'Rooming Payment Type',
				rooming_notes: 'Rooming Notes',
				travel_originCity: 'Origin City',
				travel_originState: 'Origin State',
				travel_arrivalCity: 'Arrival City',
				travel_arrivalState: 'Arrival State',
				travel_arrivalDate: 'Arrival Date',
				travel_arrivalTime: 'Arrival Time',
				travel_arrivalCarrier: 'Arrival Carrier',
				travel_arrivalFlight: 'Arrival Flight',
				travel_arrivalTicketed: 'Arrival Ticketed',
				travel_arrivalClassOfService: 'Arrival Class of Service',
				travel_arrivalLocator: 'Arrival Locator',
				travel_departureCity: 'Departure City',
				travel_departureState: 'Departure State',
				travel_destinationCity: 'Destination City',
				travel_destinationState: 'Destination State',
				travel_departureDate: 'Departure Date',
				travel_departureTime: 'Departure Time',
				travel_departureCarrier: 'Departure Carrier',
				travel_departureFlight: 'Departure Flight',
				travel_departureTicketed: 'Departure Ticketed',
				travel_departureClassOfService: 'Departure Class of Service',
				travel_departureLocator: 'Departure Locator',
				travel_notes: 'Travel Notes'
			};
			Object.assign(columns, extraColumns);
			Object.assign(columnTypes, {
				rooming_arrivalDate: 'date',
				rooming_arrivalTime: 'string',
				rooming_checkInDate: 'date',
				rooming_departureDate: 'date',
				rooming_departureTime: 'string',
				rooming_checkOutDate: 'date',
				rooming_numberOfDaysStay: 'number',
				rooming_roomType: 'string',
				rooming_hotelConfirmationNumber: 'string',
				rooming_paymentType: 'string',
				rooming_notes: 'string',
				travel_originCity: 'string',
				travel_originState: 'string',
				travel_arrivalCity: 'string',
				travel_arrivalState: 'string',
				travel_arrivalDate: 'date',
				travel_arrivalTime: 'string',
				travel_arrivalCarrier: 'string',
				travel_arrivalFlight: 'string',
				travel_arrivalTicketed: 'string',
				travel_arrivalClassOfService: 'string',
				travel_arrivalLocator: 'string',
				travel_departureCity: 'string',
				travel_departureState: 'string',
				travel_destinationCity: 'string',
				travel_destinationState: 'string',
				travel_departureDate: 'date',
				travel_departureTime: 'string',
				travel_departureCarrier: 'string',
				travel_departureFlight: 'string',
				travel_departureTicketed: 'string',
				travel_departureClassOfService: 'string',
				travel_departureLocator: 'string',
				travel_notes: 'string'
			});
		}

		const customCategories = event?.customFields?.attendees || [];
		customCategories.forEach((category) => {
			(category.fields || []).forEach((field) => {
				const key = `${category._id}*${field._id}`;
				columns[key] = field.fieldName;
				columnTypes[key] = field.fieldType || 'string';
			});
		});

		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		return { columns, columnTypes, normalizedColumns, toggledColumns };
	};

	getAttendeeFilterColumns = (event = {}) => {
		const { columns, columnTypes } = this.getAttendeeFieldColumns(event);
		return Object.keys(columns).map((key) => ({
			label: columns[key],
			key,
			value: key,
			type: columnTypes[key]
		}));
	};

	getNormalizedAttendeeFilterLayers = (groupData = {}) => {
		const sourceLayers = Array.isArray(groupData.attendeeFilterLayers)
			? groupData.attendeeFilterLayers
			: Array.isArray(groupData.attendeeFilters)
				? groupData.attendeeFilters
				: [];

		return sourceLayers
			.map((layer) => {
				if (!layer) return null;
				if (typeof layer === 'string') {
					try {
						return JSON.parse(layer);
					} catch (e) {
						return null;
					}
				}
				return layer;
			})
			.filter((layer) => layer && layer.column && layer.condition)
			.map((layer) => ({
				column: layer.column,
				condition: layer.condition,
				value: layer.value,
				concatOperator: layer.concatOperator || 'and'
			}));
	};

	normalizeGroupData = (baseGroup = {}, incomingGroup = {}) => {
		const merged = { ...baseGroup, ...incomingGroup };
		const attendeeFilterLayers = this.getNormalizedAttendeeFilterLayers(merged);
		return {
			...merged,
			dynamicGroup: typeof merged.dynamicGroup === 'boolean' ? merged.dynamicGroup : false,
			attendeeFilterLayers,
			attendeeFilters: attendeeFilterLayers
		};
	};

	//Fetch complete group information and append to current
	componentDidMount() {
		const { group } = this.state;
		this.setState({ loading: true });
		const { eventId, orgId } = this.props;
		this.props.setActiveRow(group._id)
		API().get(`Organizations/${orgId}/events/${eventId}/groups/${group._id}`).then((res) => {
			if (res.data) {
				const normalizedGroup = this.normalizeGroupData(group, res.data);
				this.setState({
					group: normalizedGroup,
					editedGroup: { ...normalizedGroup },
					loading: false
				});
			}
		});
	}
	componentWillUnmount() {
		this.props.setActiveRow(null);
	}

	refreshGroup = () => {
		const { group } = this.state;
		const { eventId, orgId } = this.props;

		API().get(`Organizations/${orgId}/events/${eventId}/groups/${group._id}`).then((res) => {
			if (res.data) {
				const normalizedGroup = this.normalizeGroupData(group, res.data);
				this.setState({
					group: normalizedGroup,
					editedGroup: { ...normalizedGroup },
					loading: false
				});
			}
		});
	};

	toggleDelete = () => {
		this.setState({ deleteGroupModalOpen: !this.state.deleteGroupModalOpen });
	};

	SectionItem = (title, sectionNo) => {
		return (
			<div
				className={`sectionTab ${sectionNo === this.state.selectedSection ? 'selected' : ''}`}
				onClick={() => {
					this.setState({ selectedSection: sectionNo });
				}}
			>
				<div className="calibreBold fs-30">{title}</div>
			</div>
		);
	};

	updateGroupInfo = (property, value) => {
		const { editedGroup } = this.state;
		this.setState({
			editedGroup: {
				...editedGroup,
				[property]: value
			},
			editing: true
		});
	};

	cancelEdit = () => {
		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});

		const g = JSON.parse(JSON.stringify(this.state.group));
		this.setState({
			editedGroup: g,
			editing: false,
			requiredFields: requiredFields
		});
	};

	addAttendees = (attendees) => {
		const { editedGroup, group } = this.state;
		const updatedAttendees = [...editedGroup.attendees, ...attendees];
		editedGroup.attendees = updatedAttendees;
		group.attendees = updatedAttendees;
		this.setState({ group: group, editedGroup: editedGroup });
		this.props.updateGroup(group._id, group);
	};

	addAttendee = (attendee, isNew) => {
		const { editedGroup, group } = this.state;
		const editedAttendees = editedGroup.attendees;
		if (!editedAttendees.find((a) => a._id == attendee._id)) editedAttendees.push(attendee);
		group.attendees = editedAttendees;
		editedGroup.attendees = editedAttendees;
		if (isNew) this.props.addNewAttendee(attendee);
		this.setState({ group: group, editedGroup: editedGroup });
		this.props.updateGroup(group._id, group);
	};

	removeAttendees = (attendees) => {
		const { editedGroup, group } = this.state;
		const updatedAttendees = editedGroup.attendees.filter((a) => !attendees.includes(a._id));
		editedGroup.attendees = updatedAttendees;
		group.attendees = updatedAttendees;
		this.updatedCheckedAttendees([]);
		this.setState({ group: group, editedGroup: editedGroup, checkedAttendees: [] });
		this.props.updateGroup(group._id, group);
	};

	removeSessions = (sessions) => {
		const { group, editedGroup } = this.state;
		const editedSessions = editedGroup.sessions.filter((s) => !sessions.includes(s._id));
		group.sessions = editedSessions;
		editedGroup.sessions = editedSessions;
		this.updatedCheckedSessions([]);
		this.setState({ group: group, editedGroup: editedGroup, checkedSessions: [] });
		this.props.updateGroup(group._id, group);
	};

	addSession = (session, isNew) => {
		const { group, editedGroup } = this.state;
		const editedSessions = editedGroup.sessions;
		if (!editedSessions.find((s) => s._id == session._id)) editedSessions.push(session);
		group.sessions = editedSessions;
		editedGroup.sessions = editedSessions;
		if (isNew) this.props.addNewSession(session);
		this.setState({ group: group, editedGroup: editedGroup });
		this.props.updateGroup(group._id, group);
	};

	addSessions = (sessions) => {
		const { editedGroup, group } = this.state;
		const updatedSessions = [...editedGroup.sessions, ...sessions];
		editedGroup.sessions = updatedSessions;
		group.sessions = updatedSessions;
		this.setState({ group: group, editedGroup: editedGroup });
		this.props.updateGroup(group._id, group);
	};

	saveInfo = () => {
		const { editedGroup } = this.state;

		const { orgId, eventId } = this.props;
		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedGroup[key] || editedGroup[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		if (valid) {
			const attendeeFilterLayers = this.getNormalizedAttendeeFilterLayers(editedGroup);
			API()
				.patch(`Organizations/${orgId}/events/${eventId}/groups/${editedGroup._id}`, {
					name: editedGroup.name,
					maxCapacityEnabled: editedGroup.maxCapacityEnabled,
					maxCapacity: editedGroup.maxCapacity,
					waitlistEnabled: editedGroup.waitlistEnabled,
					dynamicGroup: editedGroup.dynamicGroup,
					attendeeFilterLayers
				})
				.then((res) => {
					if (res.data) {
						const normalizedGroup = this.normalizeGroupData(editedGroup, res.data);
						normalizedGroup.lastEditedBy = res.data.lastEditedBy;
						this.setState({ editing: false, group: normalizedGroup, editedGroup: { ...normalizedGroup } });
						this.props.updateGroup(editedGroup._id, normalizedGroup);
					}
				})
				.catch((e) => {
					console.log(e);
					this.setState({
						invalid: true,
						editing: false
					});
				});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	getCurrentSection = () => {
		const visibleSections = this.getVisibleSections();
		return visibleSections.some((section) => section.sectionNo === this.state.selectedSection)
			? this.state.selectedSection
			: visibleSections[0]?.sectionNo ?? 0;
	};

	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex });
	};

	getVisibleSections = () => {
		const isDynamicGroup = !!this.state.editedGroup.dynamicGroup;
		const allSections = [
			{ title: 'Information', sectionNo: 0 },
			{ title: 'Attendees', sectionNo: 1 },
			{ title: 'Sessions', sectionNo: 2 },
			{ title: 'Waitlist', sectionNo: 3 }
		];

		return isDynamicGroup ? allSections.filter((section) => section.sectionNo < 2) : allSections;
	};

	renderSection() {
		const {
			addAttendeeToggle,
			importAttendeesToggle,
			addSessionToggle,
			importSessionsToggle,
			selectedSection,
			checkedAttendees,
			deleteAttendeesModalOpen,
			checkedSessions,
			deleteSessionsModalOpen
		} = this.state;

		let mainAction = [];

		switch (selectedSection) {
			case 1:
				mainAction = [
					{ onClick: this.toggleAddAttendees, label: 'Add Attendee' },
					{ onClick: this.toggleImportAttendees, label: 'Import Attendees' }
				];
				break;
			case 2:
				mainAction = [
					{ onClick: this.toggleAddSessions, label: 'Add Session' },
					{ onClick: this.toggleImportSessions, label: 'Import Sessions' }
				];
				break;

			default:
				mainAction = [];
		}

		let batchActions = [];

		switch (selectedSection) {
			case 1:
				batchActions = [
					{
						type: 'button',
						label: 'Delete Attendees',
						onClick: this.toggleDeleteAttendees,
						iconClass: 'las la-trash-alt',
						class: 'danger'
					}
				];
				break;
			case 1:
				batchActions = [
					{
						type: 'button',
						label: 'Delete Sessions',
						onClick: this.toggleDeleteSessions,
						iconClass: 'las la-trash-alt',
						class: 'danger'
					}
				];
				break;
			default:
				batchActions = [];
		}

		switch (this.state.selectedSection) {
			case 0:
				return (
					<EventGroupInfo
						editedGroup={this.state.editedGroup}
						updateGroupInfo={this.updateGroupInfo}
						readOnly={this.props.readOnly}
						requiredFields={this.state.requiredFields}
						event={this.props.event}
						columns={this.getAttendeeFilterColumns(this.props.event)}
					/>
				);
			case 3:
				return (
					<EventGroupWaitlist
						editedGroup={this.state.editedGroup}
						event={this.props.event}
						orgId={this.props.orgId}
						checkedWaitlist={this.state.checkedWaitlist}
						updateChecked={this.updatedCheckedWaitlist}
						approveWaitlistModalOpen={this.state.approveWaitlistModalOpen}
						deleteWaitlistModalOpen={this.state.deleteWaitlistModalOpen}
						toggleApproveWaitlist={this.toggleApproveWaitlist}
						toggleDeleteWaitlist={this.toggleDeleteWaitlist}
						approveWaitlistAttendees={this.approveWaitlistAttendees}
						removeWaitlistAttendees={this.removeWaitlistAttendees}
						readOnly={this.props.readOnly}
					/>
				);
			case 1:
				return (
					<EventGroupAttendees
						editedGroup={this.state.editedGroup}
						event={this.props.event}
						attendeeFieldColumns={this.getAttendeeFieldColumns(this.props.event)}
						index={this.props.index}
						orgId={this.props.orgId}
						loadMoreAttendees={this.props.loadMoreAttendees}
						addAttendees={this.addAttendees}
						removeAttendees={this.removeAttendees}
						applyAttendeeFilters={this.props.applyAttendeeFilters}
						updateGroup={this.refreshGroup}
						readOnly={this.props.readOnly}
						addAttendee={this.addAttendee}
						addAttendeeToggle={addAttendeeToggle}
						importAttendeesToggle={importAttendeesToggle}
						toggleAddAttendees={this.toggleAddAttendees}
						toggleImportAttendees={this.toggleImportAttendees}
						toggleRemoveAttendees={this.toggleDeleteAttendees}
						batchActions={batchActions}
						updateChecked={this.updatedCheckedAttendees}
						checkedAttendees={checkedAttendees}
						deleteAttendeesModalOpen={deleteAttendeesModalOpen}
						updateGroupInfo={this.updateGroupInfo}
					/>
				);
			case 2:
				return (
					<EventGroupSessions
						editedGroup={this.state.editedGroup}
						event={this.props.event}
						index={this.props.index}
						orgId={this.props.orgId}
						loadMoreSessions={this.props.loadMoreSessions}
						addSessions={this.addSessions}
						removeSessions={this.removeSessions}
						readOnly={this.props.readOnly}
						addSessionToggle={addSessionToggle}
						importSessionsToggle={importSessionsToggle}
						toggleAddSessions={this.toggleAddSessions}
						toggleImportSessions={this.toggleImportSessions}
						toggleRemoveSessions={this.toggleDeleteSessions}
						batchActions={batchActions}
						updateChecked={this.updatedCheckedSessions}
						checkedSessions={checkedSessions}
						deleteSessionsModalOpen={deleteSessionsModalOpen}
					/>
				);
			default:
		}
	}

	toggleAddAttendees = () => {
		this.setState({ addAttendeeToggle: !this.state.addAttendeeToggle });
	};
	toggleImportAttendees = () => {
		this.setState({ importAttendeesToggle: !this.state.importAttendeesToggle });
	};
	toggleDeleteAttendees = () => {
		this.setState({
			deleteAttendeesModalOpen: !this.state.deleteAttendeesModalOpen
		});
	};

	toggleDeleteSessions = () => {
		this.setState({
			deleteSessionsModalOpen: !this.state.deleteSessionsModalOpen
		});
	};

	toggleAddSessions = () => {
		this.setState({ addSessionToggle: !this.state.addSessionToggle });
	};
	toggleImportSessions = () => {
		this.setState({ importSessionsToggle: !this.state.importSessionsToggle });
	};

	updatedCheckedAttendees = (checked) => {
		this.setState({ checkedAttendees: checked });
	};

	updatedCheckedSessions = (checked) => {
		this.setState({ checkedSessions: checked });
	};

	updatedCheckedWaitlist = (checked) => {
		this.setState({ checkedWaitlist: checked });
	};

	toggleApproveWaitlist = () => {
		this.setState({ approveWaitlistModalOpen: !this.state.approveWaitlistModalOpen });
	};

	toggleDeleteWaitlist = () => {
		this.setState({ deleteWaitlistModalOpen: !this.state.deleteWaitlistModalOpen });
	};

	approveWaitlistAttendees = (allApprovedAttendees, newAttendees) => {
		const { editedGroup, group } = this.state;
		const updatedAttendees = [...editedGroup.attendees, ...newAttendees];
		const allApprovedIds = allApprovedAttendees.map((a) => a._id);
		const updatedWaitlist = (editedGroup.waitlist || []).filter((a) => !allApprovedIds.includes(a._id));
		editedGroup.attendees = updatedAttendees;
		editedGroup.waitlist = updatedWaitlist;
		group.attendees = updatedAttendees;
		group.waitlist = updatedWaitlist;
		this.setState({ group, editedGroup, checkedWaitlist: {} });
		this.props.updateGroup(group._id, group);
	};

	removeWaitlistAttendees = (removedIds) => {
		const { editedGroup, group } = this.state;
		const updatedWaitlist = (editedGroup.waitlist || []).filter((a) => !removedIds.includes(a._id));
		editedGroup.waitlist = updatedWaitlist;
		group.waitlist = updatedWaitlist;
		this.setState({ group, editedGroup, checkedWaitlist: {} });
		this.props.updateGroup(group._id, group);
	};

	render() {
		const { group, deleteGroupModalOpen, loading, editing, selectedSection, deleteAttendeesModalOpen, checkedWaitlist } = this.state;
		const { eventId, event } = this.props;
		const visibleSections = this.getVisibleSections();
		const currentSection = this.getCurrentSection();
		const selectedTabIndex = visibleSections.findIndex((section) => section.sectionNo === currentSection);
		let mainAction = [];

		switch (selectedSection) {
			case 1:
				mainAction = [
					{ onClick: this.toggleAddAttendees, label: 'Add Attendee' },
					{ onClick: this.toggleImportAttendees, label: 'Import Attendees' }
				];
				break;
			case 2:
				mainAction = [
					{ onClick: this.toggleAddSessions, label: 'Add Session' },
					{ onClick: this.toggleImportSessions, label: 'Import Sessions' }
				];
				break;

			default:
				mainAction = [];
		}

		let batchActions = [];
		let checkedEntryCount = 0;
		let entriesLength = 0;
		let uncheckEntries = null;

		switch (selectedSection) {
			case 1:
				batchActions = [
					{
						type: 'button',
						label: 'Delete Attendees',
						onClick: this.toggleDeleteAttendees,
						iconClass: 'las la-trash-alt',
						class: 'danger'
					}
				];
				checkedEntryCount = Object.keys(this.state.checkedAttendees).length;
				entriesLength = group.attendees.length;
				uncheckEntries = () => {
					this.setState({ checkedAttendees: [] });
				};
				break;
			case 2:
				batchActions = [
					{
						type: 'button',
						label: 'Delete Sessions',
						onClick: this.toggleDeleteSessions,
						iconClass: 'las la-trash-alt',
						class: 'danger'
					}
				];
				checkedEntryCount = Object.keys(this.state.checkedSessions).length;
				entriesLength = group.sessions.length;
				uncheckEntries = () => {
					this.setState({ checkedSessions: [] });
				};
				break;
			case 3:
				batchActions = [
					{
						type: 'button',
						label: 'Approve',
						onClick: this.toggleApproveWaitlist,
						iconClass: 'las la-check',
						class: 'prim'
					},
					{
						type: 'button',
						label: 'Remove',
						onClick: this.toggleDeleteWaitlist,
						iconClass: 'las la-trash-alt',
						class: 'danger'
					}
				];
				checkedEntryCount = Object.keys(checkedWaitlist).length;
				entriesLength = (group.waitlist || []).length;
				uncheckEntries = () => {
					this.setState({ checkedWaitlist: {} });
				};
				break;
			default:
				batchActions = [];
		}
		return (
			<div className="sectionContainer ">
				<SectionHeader
					editing={editing}
					title={group.name}
					description={"Insightful information about the group**"}
					enableLastLink={true}
					/* breadcrumbs={[
						{
							name: event.name
						},
						{
							name: 'Groups'
						}
					]} */
					subActions={[{ onClick: this.toggleDelete, label: <span><i className='las la-trash mr-10'></i>Delete Group</span> }]}
					closeButton={true}
				>
					<TabsContainer
						tabs={visibleSections.map((section) => ({ title: section.title }))}
						updateSelected={this.updateSelected}
						selectedIndex={selectedTabIndex}
					/></SectionHeader>
				<div className="sectionBody">
					{!loading && this.renderSection()}
				</div>
				<LoadingWizard text="LOADING GROUP" loading={loading} />
				<SectionFooter saveEdit={this.saveInfo} cancelEdit={this.cancelEdit} updatedAt={group.updatedAt} editing={editing} lastEditedBy={group.lastEditedBy} />
				{deleteGroupModalOpen && <DeleteGroupModal
					isOpen={deleteGroupModalOpen}
					toggle={this.toggleDelete}
					group={group}
					submit={this.props.deleteGroup}
				/>}
			</div>
		);
	}
}

export default withRouter(EventGroup);
